<template>
    <div class="main">
        <header>
            <a class="header_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/logo.jpg">
            </a>
            <div class="header_right">
                <router-link class="header_link" to="/ubiadmin/AdminStaffList">スタッフー覧</router-link>
                <router-link class="header_link" to="/ubiadmin/AdminNewsList">ニュース一覧/編集</router-link>
                <p>{{$store.state.userName}}</p>
                <button class="logout_btn" v-on:click="logout">ログアウト</button>
            </div>
        </header>
        <h3 v-show="err_catch" class="err_msg">エラー</h3>
        <div class="container">
            <h1>スタッフ登録</h1>
            <div class="admin_news_edit_wrap">
                <div class="news_edit_wrap">
                    <p>登録ファイルを選択してください。</p>
                    <div class="news_edit_box">
                        <input type="file" id="fake_text_box" class="file" accept=".csv" value="" readonly onClick="$('#file').click();" placeholder="CSVファイル" name="file" v-on:change="fileSelected">
                    </div>
                </div>
            </div>
            <div class="news_edit_btns">
                <router-link to="/ubiadmin/AdminTop">戻る</router-link>
                <button v-on:click="fileUpload">内容確認</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  data: function () {
    return {
      fileInfo: '',
      user: '',
      err_catch: false,
      url_protcol: 'https://',
      domain: '1304kanri.ubiquitous-p.com',
      url_path: '/rest/upload_csv/'
    }
  },
  methods: {
    fileSelected (event) {
      this.fileInfo = event.target.files[0]
    },
    fileUpload () {
      const formData = new FormData()
      formData.append('file', this.fileInfo)
      formData.append('name',this.$store.state.userName)
      axios.post(this.url_protcol + this.domain + this.url_path, formData,{
          headers: {
                    "Content-Type": "application/json", 
                    "Authorization": this.$store.state.userToken
                }
      }).then(response => {
        this.user = response.data
        this.$router.push({name: 'AdminStaffConfirm', params: {'json_data': this.user}})
      }).catch(error => {
        this.err_catch = true
        console.log(error)
      })
    },
    logout() {
        this.$store.commit('reset');
        this.$router.push({name:'aLogin'});
    }
  }
}
</script>

<style scoped>

.main {
    width: 100vw;
    height: 100vh;
    background-size: cover;
}

.container {
    width: 100vw;
    height: 93vh;
}

h1 {
    margin: 10px 30px;
}

p.title_txt {
    margin: 10px 30px;
}

.admin_news_edit_wrap {
    width: 90vw;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: rgb(228 228 228) 1px 1px 8px;
    padding: 30px 80px;
}

.news_edit_wrap {
    width: 70%;
    margin: 30px 0;
}

p.input_txt {
    color: #FF0202;
    font-size: .8em;
    text-align: right;
    margin-right: 20px;
}

.news_edit_box {
    display: flex;
    position: relative;
}

.news_edit_box p {
    width: 150px;
    line-height: 40px;
}

input.file{
    line-height: 37.5px;
}

input, textarea {
    display: block;
    width: 100%;
    height: 40px;
    padding: 0 10px;
    border-radius: 5px;
    border: 1px solid #888;
    box-shadow: rgb(210 210 210) 1px 1px 3px inset;
}

textarea {
    resize: none;
    height: 100px;
    padding-top: 10px;
}

.delivery_date_box {
    border-top: 1px solid;
    margin-top: 30px;
    padding-top: 20px;
}

.delivery_date_box input {
    width: 60%;
}

label.choise_btn {
    display: block;
    width: 80px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #D7E37D;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
    position: absolute;
    right: 20px;
    cursor:pointer;
}

input#file_upload {
    display: none;
}

.news_edit_btns {
    display: flex;
    justify-content: space-between;
    width: 90vw;
    margin: 0 auto;
    padding: 15px;
}

.news_edit_btns a {
    display: block;
    width: 150px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #4DC0AD;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
}

.news_edit_btns button {
    background: none;
    border: none;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: block;
    width: 150px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #4DC0AD;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
}

.err_msg {
    color: #ff6d6d;
    text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/AdminStaffEdit.vue